/**
 * Localization strings for app resources
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const resourcesText = createDictionary({
  appResources: {
    'en-us': 'App Resources',
    'ru-ru': 'Ресурсы приложений',
    'es-es': 'Recursos de la aplicación',
    'fr-fr': "Ressources de l'application",
    'uk-ua': 'Ресурси програми',
    'de-ch': 'App Ressourcen',
  },
  formDefinition: {
    'en-us': 'Form Definition',
    'ru-ru': 'Определение формы',
    'es-es': 'Definición de formulario',
    'fr-fr': 'Définition du formulaire',
    'uk-ua': 'Визначення форми',
    'de-ch': 'Formular Definition',
  },
  formDefinitions: {
    'en-us': 'Form Definition',
    'ru-ru': 'Определение формы',
    'es-es': 'Definición de formulario',
    'fr-fr': 'Définition du formulaire',
    'uk-ua': 'Визначення форми',
    'de-ch': 'Formulardefinition',
  },
  loadFile: {
    'en-us': 'Load File',
    'ru-ru': 'Загрузить файл',
    'es-es': 'Cargar archivo',
    'fr-fr': 'Fichier de chargement',
    'uk-ua': 'Завантажити файл',
    'de-ch': 'Datei Laden',
  },
  globalResources: {
    'en-us': 'Global Resources',
    'ru-ru': 'Глобальные ресурсы',
    'es-es': 'Recursos globales',
    'fr-fr': 'Ressources mondiales',
    'uk-ua': 'Глобальні ресурси',
    'de-ch': 'Globale Ressourcen',
  },
  disciplineResources: {
    'en-us': 'Discipline Resources',
    'ru-ru': 'Дисциплинарные ресурсы',
    'es-es': 'Recursos de disciplina',
    'fr-fr': 'Ressources disciplinaires',
    'uk-ua': 'Дисциплінарні ресурси',
    'de-ch': 'Disziplin-Ressourcen',
  },
  type: {
    'en-us': 'Type',
    'ru-ru': 'Тип',
    'es-es': 'Tipo',
    'fr-fr': 'Taper',
    'uk-ua': 'Тип',
    'de-ch': 'Typ',
  },
  userTypes: {
    'en-us': 'User Types',
    'ru-ru': 'Типы пользователей',
    'es-es': 'Tipos de usuarios',
    'fr-fr': "Types d'utilisateurs",
    'uk-ua': 'Типи користувачів',
    'de-ch': 'Benutzertypen',
  },
  resources: {
    'en-us': 'Resources',
    'ru-ru': 'Ресурсы',
    'es-es': 'Recursos',
    'fr-fr': 'Ressources',
    'uk-ua': 'Ресурси',
    'de-ch': 'Ressourcen',
  },
  subCategories: {
    'en-us': 'Sub-categories',
    'ru-ru': 'Подкатегории',
    'es-es': 'Subcategorías',
    'fr-fr': 'Sous-catégories',
    'uk-ua': 'Підкатегорії',
    'de-ch': 'Unterkategorien',
  },
  addResource: {
    'en-us': 'Add Resource',
    'ru-ru': 'Добавить ресурс',
    'es-es': 'Agregar recurso',
    'fr-fr': 'Ajouter une ressource',
    'uk-ua': 'Додати ресурс',
    'de-ch': 'Ressource hinzufügen',
  },
  appResource: {
    'en-us': 'App Resource',
    'ru-ru': 'Подкатегории',
    'es-es': 'Subcategorías',
    'fr-fr': 'Sous-catégories',
    'uk-ua': 'Підкатегорії',
    'de-ch': 'App Ressource',
  },
  rssExportFeed: {
    'en-us': 'RSS Export Feed',
    'ru-ru': 'RSS-канал экспорта',
    'es-es': 'Fuente de exportación RSS',
    'fr-fr': "Flux d'exportation RSS",
    'uk-ua': 'Канал експорту RSS',
    'de-ch': 'RSS-Export-Feed',
  },
  exports: {
    'en-us': 'Exports',
    'de-ch': 'Exporte',
    'es-es': 'Exportaciones',
    'fr-fr': 'Exportations',
    'ru-ru': 'Экспорт',
    'uk-ua': 'Експорт',
  },
  expressSearchConfig: {
    'en-us': 'Express Search Config',
    'ru-ru': 'Конфигурация экспресс-поиска',
    'es-es': 'Configuración de búsqueda rápida',
    'fr-fr': 'Configuration de recherche express',
    'uk-ua': 'Конфігурація експрес-пошуку',
    'de-ch': 'Express Suche Konfigurieren',
  },
  typeSearches: {
    'en-us': 'Type Searches',
    'de-ch': 'Typsuchen',
    'es-es': 'Tipo de búsquedas',
    'fr-fr': 'Recherches de types',
    'ru-ru': 'Тип поиска',
    'uk-ua': 'Пошук типів',
  },
  webLinks: {
    'en-us': 'Web Links',
    'ru-ru': 'Веб ссылки',
    'es-es': 'Enlaces web',
    'fr-fr': 'Liens web',
    'uk-ua': 'Веб-посилання',
    'de-ch': 'Weblinks',
  },
  uiFormatters: {
    'en-us': 'Field Formatters',
    'ru-ru': 'Форматировщики полей',
    'es-es': 'Formateadores de campo',
    'fr-fr': 'Formateurs de champs',
    'uk-ua': 'Форматувальники полів',
    'de-ch': 'Feldformatierer',
  },
  dataObjectFormatters: {
    'en-us': 'Record Formatters',
    'ru-ru': 'Форматеры записи',
    'es-es': 'Formateadores de registros',
    'uk-ua': 'Форматувальники записів',
    'de-ch': 'Datensatz-Formatierer',
    'fr-fr': "Formateurs d'enregistrement",
  },
  formatter: {
    'en-us': 'Table Format',
    'de-ch': 'Tabellenformat',
    'es-es': 'Formato de tabla',
    'fr-fr': 'Format du tableau',
    'ru-ru': 'Формат таблицы',
    'uk-ua': 'Формат таблиці',
  },
  formatterDescription: {
    'en-us': `
      The “Table Format” controls how data from a specific table is shown in
      query results, exports, and query combo boxes. It determines the fields to
      display and their order. Conditional formatting can be configured based
      on a value in the record.
    `,
    'de-ch': `
      Das „Tabellenformat“ steuert, wie Daten aus einer bestimmten Tabelle in
      Abfrageergebnissen, Exporten und Abfragekombinationsfeldern angezeigt
      werden. Es bestimmt die anzuzeigenden Felder und deren Reihenfolge. Die
      bedingte Formatierung kann basierend auf einem Wert im Datensatz
      konfiguriert werden.
    `,
    'es-es': `
      El "Formato de tabla" controla cómo se muestran los datos de una tabla
      específica en los resultados de la consulta, las exportaciones y los
      cuadros combinados de la consulta. Determina los campos a mostrar y su
      orden. El formato condicional se puede configurar en función de un valor
      en el registro.
    `,
    'fr-fr': `
      Le « Format de table » contrôle la manière dont les données d'une table
      spécifique sont affichées dans les résultats de requête, les exportations
      et les listes déroulantes de requête. Il détermine les champs à afficher
      et leur ordre. La mise en forme conditionnelle peut être configurée en
      fonction d'une valeur dans l'enregistrement.
    `,
    'ru-ru': `
      «Формат таблицы» определяет, как данные из определенной таблицы
      отображаются в результатах запроса, экспорте и полях со списком запроса.
      Он определяет поля для отображения и их порядок. Условное форматирование
      можно настроить на основе значения в записи.
    `,
    'uk-ua': `
      «Формат таблиці» керує тим, як дані з певної таблиці відображаються в
      результатах запитів, експорті та комбінованих полях запитів. Він визначає
      поля для відображення та їх порядок. Умовне форматування можна налаштувати
      на основі значення в записі.
    `,
  },
  aggregator: {
    'en-us': 'Table Aggregation',
    'de-ch': 'Tabellenaggregation',
    'es-es': 'Agregación de tablas',
    'fr-fr': 'Agrégation de tables',
    'ru-ru': 'Агрегация таблиц',
    'uk-ua': 'Агрегація таблиць',
  },
  aggregatorDescription: {
    'en-us': `
      The “Table Aggregation” controls how multiple table records are
      consolidated together into a single text string. The table format,
      separator, suffix, sort field, and record preview limit are customizable.
      It can be displayed in query results and table formats.
    `,
    'de-ch': `
      Die „Tabellenaggregation“ steuert, wie mehrere Tabellendatensätze zu einer
      einzigen Textzeichenfolge zusammengefasst werden. Tabellenformat,
      Trennzeichen, Suffix, Sortierfeld und Datensatzvorschaulimit sind
      anpassbar. Es kann in Abfrageergebnissen und Tabellenformaten angezeigt
      werden.
    `,
    'es-es': `
      La "Agregación de tablas" controla cómo se consolidan varios registros de
      tablas en una sola cadena de texto. El formato de la tabla, el separador,
      el sufijo, el campo de clasificación y el límite de vista previa de
      registros se pueden personalizar. Se puede mostrar en resultados de
      consultas y formatos de tablas.
    `,
    'fr-fr': `
      L'« Agrégation de table » contrôle la manière dont plusieurs
      enregistrements de table sont consolidés en une seule chaîne de texte. Le
      format du tableau, le séparateur, le suffixe, le champ de tri et la limite
      d'aperçu des enregistrements sont personnalisables. Il peut être affiché
      sous forme de résultats de requête et de formats de tableau.
    `,
    'ru-ru': `
      «Агрегация таблиц» управляет тем, как несколько записей таблицы
      объединяются в одну текстовую строку. Формат таблицы, разделитель,
      суффикс, поле сортировки и ограничение предварительного просмотра записи
      можно настроить. Его можно отобразить в результатах запроса и в форматах
      таблиц.
    `,
    'uk-ua': `
      «Агрегація таблиць» контролює, як кілька записів таблиці об’єднуються
      разом в один текстовий рядок. Формат таблиці, роздільник, суфікс, поле
      сортування та ліміт попереднього перегляду запису можна налаштувати. Він
      може відображатися в результатах запитів і у форматах таблиць.
    `,
  },
  formattedResource: {
    'en-us': 'Formatted Resource',
    'de-ch': 'Formatierte Ressource',
    'es-es': 'Recurso formateado',
    'fr-fr': 'Ressource formatée',
    'ru-ru': 'Форматированный ресурс',
    'uk-ua': 'Відформатований ресурс',
  },
  availableFormatters: {
    'en-us': 'Available Table Formats',
    'de-ch': 'Verfügbare Tabellenformate',
    'es-es': 'Formatos de tabla disponibles',
    'fr-fr': 'Formats de tableaux disponibles',
    'ru-ru': 'Доступные форматы таблиц',
    'uk-ua': 'Доступні формати таблиць',
  },
  availableAggregators: {
    'en-us': 'Available Table Aggregations',
    'de-ch': 'Verfügbare Tabellenaggregationen',
    'es-es': 'Agregaciones de tablas disponibles',
    'fr-fr': 'Agrégations de tables disponibles',
    'ru-ru': 'Доступные агрегаты таблиц',
    'uk-ua': 'Доступні агрегації таблиць',
  },
  availableWebLink: {
    'en-us': 'Available Web Links',
    'de-ch': 'Verfügbare Weblinks',
    'es-es': 'Enlaces web disponibles',
    'fr-fr': 'Liens Web disponibles',
    'ru-ru': 'Доступные веб-ссылки',
    'uk-ua': 'Доступні веб-посилання',
  },
  selectDefaultFormatter: {
    'en-us': 'Please select a default record formatter for this table',
    'de-ch':
      'Bitte wählen Sie einen Standarddatensatzformatierer für diese Tabelle',
    'es-es':
      'Seleccione un formateador de registros predeterminado para esta tabla',
    'fr-fr': `
      Veuillez sélectionner un formateur d'enregistrement par défaut pour cette
      table
    `,
    'ru-ru': `
      Пожалуйста, выберите форматирование записей по умолчанию для этой таблицы.
    `,
    'uk-ua': 'Виберіть стандартний формат запису для цієї таблиці',
  },
  duplicateFormatters: {
    'en-us': 'Record formatter names must be unique',
    'de-ch': 'Datensatzformatierernamen müssen eindeutig sein',
    'es-es': 'Los nombres de los formateadores de registros deben ser únicos.',
    'fr-fr': "Les noms du formateur d'enregistrement doivent être uniques",
    'ru-ru': 'Имена средств форматирования записей должны быть уникальными.',
    'uk-ua': 'Імена форматування записів мають бути унікальними',
  },
  dataEntryTables: {
    'en-us': 'Data Entry Tables',
    'ru-ru': 'Таблицы ввода данных',
    'es-es': 'Tablas de entrada de datos',
    'fr-fr': 'Tableaux de saisie de données',
    'uk-ua': 'Таблиці введення даних',
    'de-ch': 'Dateneingabetabellen',
  },
  interactionsTables: {
    'en-us': 'Interactions Tables',
    'ru-ru': 'Таблицы взаимодействий',
    'es-es': 'Tablas de interacciones',
    'fr-fr': "Tableaux d'interactions",
    'uk-ua': 'Таблиці взаємодій',
    'de-ch': 'Interaktionstabellen',
  },
  otherXmlResource: {
    'en-us': 'Other XML Resource',
    'ru-ru': 'Выберите тип ресурса',
    'es-es': 'Seleccionar tipo de recurso',
    'fr-fr': 'Sélectionnez le type de ressource',
    'uk-ua': 'Виберіть тип ресурсу',
    'de-ch': 'Andere XML-Ressource',
  },
  otherJsonResource: {
    'en-us': 'Other JSON Resource',
    'ru-ru': 'Другой ресурс JSON',
    'es-es': 'Otro recurso JSON',
    'fr-fr': 'Autre ressource JSON',
    'uk-ua': 'Інший ресурс JSON',
    'de-ch': 'Andere JSON-Ressource',
  },
  otherPropertiesResource: {
    'en-us': 'Other Properties Resource',
    'ru-ru': 'Ресурс «Другие свойства»',
    'es-es': 'Recurso de otras propiedades',
    'fr-fr': 'Autres ressources de propriétés',
    'uk-ua': 'Ресурс інших властивостей',
    'de-ch': 'Andere Eigenschaften Ressource',
  },
  otherAppResource: {
    'en-us': 'Other Resource',
    'ru-ru': 'Другой ресурс',
    'es-es': 'Otro recurso',
    'fr-fr': 'Autre ressource',
    'uk-ua': 'Інший ресурс',
    'de-ch': 'Andere Ressource',
  },
  filters: {
    'en-us': 'Filters',
    'ru-ru': 'Фильтры',
    'es-es': 'Filtros',
    'fr-fr': 'Filtres',
    'uk-ua': 'Фільтри',
    'de-ch': 'Filter',
  },
  custom: {
    'en-us': 'Custom',
    'ru-ru': 'Обычай',
    'es-es': 'Costumbre',
    'fr-fr': 'Coutume',
    'uk-ua': 'Custom',
    'de-ch': 'Individuell',
  },
  leafletLayers: {
    'en-us': 'Leaflet Layers',
    'ru-ru': 'Слои листовок',
    'es-es': 'Capas de folletos',
    'fr-fr': 'Couches de brochures',
    'uk-ua': 'Шари листівок',
    'de-ch': 'Leaflet-Layer',
  },
  textEditor: {
    'en-us': 'Text Editor',
    'ru-ru': 'Текстовый редактор',
    'es-es': 'Editor de texto',
    'fr-fr': 'Éditeur de texte',
    'uk-ua': 'Текстовий редактор',
    'de-ch': 'Text-Editor',
  },
  xmlEditor: {
    'en-us': 'XML Editor',
    'ru-ru': 'XML-редактор',
    'es-es': 'Editor XML',
    'fr-fr': 'Éditeur XML',
    'uk-ua': 'Редактор XML',
    'de-ch': 'XML-Editor',
  },
  jsonEditor: {
    'en-us': 'JSON Editor',
    'ru-ru': 'Редактор JSON',
    'es-es': 'Editor JSON',
    'fr-fr': 'Éditeur JSON',
    'uk-ua': 'Редактор JSON',
    'de-ch': 'Separator',
  },
  visualEditor: {
    'en-us': 'Visual Editor',
    'ru-ru': 'Визуальный редактор',
    'es-es': 'editor visual',
    'fr-fr': 'Éditeur visuel',
    'uk-ua': 'Візуальний редактор',
    'de-ch': 'Visueller Editor',
  },
  selectResourceType: {
    'en-us': 'Select Resource Type',
    'ru-ru': 'Выберите тип ресурса',
    'es-es': 'Seleccionar tipo de recurso',
    'fr-fr': 'Sélectionnez le type de ressource',
    'uk-ua': 'Виберіть тип ресурсу',
    'de-ch': 'Ressourcentyp auswählen',
  },
  globalPreferences: {
    'en-us': 'Global Preferences',
    'ru-ru': 'Глобальные настройки',
    'es-es': 'Preferencias globales',
    'fr-fr': 'Préférences globales',
    'uk-ua': 'Глобальні налаштування',
    'de-ch': 'Globale Einstellungen',
  },
  remotePreferences: {
    'en-us': 'Remote Preferences',
    'ru-ru': 'Удаленные настройки',
    'es-es': 'Preferencias remotas',
    'fr-fr': 'Préférences à distance',
    'uk-ua': 'Віддалені параметри',
    'de-ch': 'Remote-Einstellungen',
  },
  failedParsingXml: {
    'en-us': 'Failed to parse XML',
    'ru-ru': 'Не удалось разобрать XML',
    'de-ch': 'XML konnte nicht analysiert werden',
    'es-es': 'No se pudo analizar XML',
    'fr-fr': "Échec de l'analyse XML",
    'uk-ua': 'Не вдалося проаналізувати XML',
  },
  name: {
    'en-us': 'Name',
    'ru-ru': 'Имя',
    'de-ch': 'Name',
    'es-es': 'Nombre',
    'fr-fr': 'Nom',
    'uk-ua': "Ім'я",
  },
  title: {
    'en-us': 'Title',
    'ru-ru': 'Заголовок',
    'de-ch': 'Titel',
    'es-es': 'Título',
    'fr-fr': 'Titre',
    'uk-ua': 'Назва',
  },
  default: {
    'en-us': 'Default',
    'ru-ru': 'По умолчанию',
    'de-ch': 'Standard',
    'es-es': 'Por defecto',
    'fr-fr': 'Défaut',
    'uk-ua': 'За замовчуванням',
  },
  separator: {
    'en-us': 'Separator',
    'ru-ru': 'Разделитель',
    'de-ch': 'Separator',
    'es-es': 'Separador',
    'fr-fr': 'Séparateur',
    'uk-ua': 'Роздільник',
  },
  suffix: {
    'en-us': 'Suffix',
    'ru-ru': 'Суффикс',
    'de-ch': 'Suffix',
    'es-es': 'Sufijo',
    'fr-fr': 'Suffixe',
    'uk-ua': 'Суфікс',
  },
  limit: {
    'en-us': 'Limit',
    'ru-ru': 'Лимит',
    'de-ch': 'Grenze',
    'es-es': 'Límite',
    'fr-fr': 'Limite',
    'uk-ua': 'Ліміт',
  },
  defaultInline: {
    'en-us': '(default)',
    'de-ch': '(Standard)',
    'es-es': '(por defecto)',
    'fr-fr': '(défaut)',
    'ru-ru': '(по умолчанию)',
    'uk-ua': '(за умовчанням)',
  },
  sortField: {
    'en-us': 'Sort Field',
    'ru-ru': 'Сортировать поле',
    'de-ch': 'Sortierfeld',
    'es-es': 'Ordenar campo',
    'fr-fr': 'Champ de tri',
    'uk-ua': 'Поле сортування',
  },
  preview: {
    'en-us': 'Preview',
    'ru-ru': 'Предварительный просмотр',
    'de-ch': 'Vorschau',
    'es-es': 'Avance',
    'fr-fr': 'Aperçu',
    'uk-ua': 'Попередній перегляд',
  },
  previewExplainer: {
    'en-us': 'Search your collection records to preview the record formatter',
    'de-ch': `
      Durchsuchen Sie Ihre Sammlungsdatensätze, um eine Vorschau des
      Datensatzformatierers anzuzeigen
    `,
    'es-es': `
      Busque los registros de su colección para obtener una vista previa del
      formateador de registros
    `,
    'fr-fr': `
      Recherchez les enregistrements de votre collection pour prévisualiser le
      formateur d'enregistrements
    `,
    'ru-ru': `
      Выполните поиск в записях своей коллекции, чтобы просмотреть средство
      форматирования записей.
    `,
    'uk-ua': `
      Виконайте пошук у своїх записах колекції, щоб переглянути інструмент
      форматування записів
    `,
  },
  editorNotAvailable: {
    'en-us': 'Visual editor is not available for this resource',
    'de-ch': 'Für diese Ressource ist kein visueller Editor verfügbar',
    'es-es': 'El editor visual no está disponible para este recurso.',
    'fr-fr': "L'éditeur visuel n'est pas disponible pour cette ressource",
    'ru-ru': 'Визуальный редактор недоступен для этого ресурса.',
    'uk-ua': 'Візуальний редактор недоступний для цього ресурсу',
  },
  definition: {
    'en-us': 'Definition',
    'de-ch': 'Definition',
    'es-es': 'Definición',
    'fr-fr': 'Définition',
    'ru-ru': 'Определение',
    'uk-ua': 'Визначення',
  },
  addDefinition: {
    'en-us': 'Add definition',
    'de-ch': 'Definition hinzufügen',
    'es-es': 'Agregar definición',
    'fr-fr': 'Ajouter une définition',
    'ru-ru': 'Добавить определение',
    'uk-ua': 'Додайте визначення',
  },
  deleteDefinition: {
    'en-us': 'Delete definition',
    'de-ch': 'Definition löschen',
    'es-es': 'Eliminar definición',
    'fr-fr': 'Supprimer la définition',
    'ru-ru': 'Удалить определение',
    'uk-ua': 'Видалити визначення',
  },
  urlPart: {
    'en-us': 'URL part',
    'de-ch': 'URL-Teil',
    'es-es': 'Otro recurso JSON',
    'fr-fr': 'Autre ressource JSON',
    'ru-ru': 'Другой ресурс JSON',
    'uk-ua': 'Інший ресурс JSON',
  },
  addField: {
    'en-us': 'Add field',
    'de-ch': 'Feld hinzufügen',
    'es-es': 'Agregue campo',
    'fr-fr': 'Ajouter le champ',
    'ru-ru': 'Добавить поле',
    'uk-ua': 'Додати поле',
  },
  thisField: {
    'en-us': 'This field',
    'de-ch': 'Dieses Feld',
    'es-es': 'Este campo',
    'fr-fr': 'Ce champ',
    'ru-ru': 'Это поле',
    'uk-ua': 'Це поле',
  },
  selectTableFirst: {
    'en-us': 'Select table first',
    'de-ch': 'Zuerst Tabelle auswählen',
    'es-es': 'Seleccione la tabla primero',
    'fr-fr': "Sélectionnez d'abord le tableau",
    'ru-ru': 'Сначала выберите таблицу',
    'uk-ua': 'Спочатку виберіть таблицю',
  },
  conditionFieldValue: {
    'en-us': 'Condition Field Value',
    'de-ch': 'Bedingungsfeldwert',
    'es-es': 'Valor del campo de condición',
    'fr-fr': 'Valeur du champ de condition',
    'ru-ru': 'Значение поля условия',
    'uk-ua': 'Умова Значення поля',
  },
  conditionDescription: {
    'en-us': `
      This format will be used only if the condition field value equals this
      condition and is not null.
    `,
    'de-ch': `
      Dieses Format wird nur verwendet, wenn der Wert des Bedingungsfelds dieser
      Bedingung entspricht und nicht null ist.
    `,
    'es-es': `
      Este formato se utilizará solo si el valor del campo de condición es igual
      a esta condición y no es nulo.
    `,
    'fr-fr': `
      Ce format sera utilisé uniquement si la valeur du champ de condition est
      égale à cette condition et n'est pas nulle.
    `,
    'ru-ru': `
      Этот формат будет использоваться только в том случае, если значение поля
      условия равно этому условию и не равно нулю.
    `,
    'uk-ua': `
      Цей формат використовуватиметься, лише якщо значення поля умови дорівнює
      цій умові й не є нульовим.
    `,
  },
  wrongScopeWarning: {
    'en-us': `
      This resource belongs to a different collection/discipline than the one
      you are currently in. It's recommended to switch collection before editing
      this resource
    `,
    'de-ch': `
      Diese Ressource gehört zu einer anderen Sammlung/Disziplin als der, in der
      Sie sich gerade befinden. Es wird empfohlen, die Sammlung zu wechseln,
      bevor Sie diese Ressource bearbeiten
    `,
    'es-es': `
      Este recurso pertenece a una colección/disciplina diferente a la que se
      encuentra actualmente. Se recomienda cambiar de colección antes de editar
      este recurso.
    `,
    'fr-fr': `
      Cette ressource appartient à une collection/discipline différente de celle
      dans laquelle vous vous trouvez actuellement. Il est recommandé de
      changer de collection avant de modifier cette ressource.
    `,
    'ru-ru': `
      Этот ресурс принадлежит к другой коллекции/дисциплине, отличной от той, в
      которой вы сейчас находитесь. Перед редактированием этого ресурса
      рекомендуется сменить коллекцию.
    `,
    'uk-ua': `
      Цей ресурс належить до іншої колекції/дисципліни, ніж та, у якій ви зараз
      перебуваєте. Рекомендовано змінити колекцію перед редагуванням цього
      ресурсу
    `,
  },
  thisFieldName: {
    'en-us': 'This field name (for preview purposes only)',
    'de-ch': 'Dieser Feldname (nur für Vorschauzwecke)',
    'es-es': 'Este nombre de campo (solo para fines de vista previa)',
    'fr-fr': "Ce nom de champ (à des fins d'aperçu uniquement)",
    'ru-ru': 'Имя этого поля (только для целей предварительного просмотра)',
    'uk-ua': 'Назва цього поля (лише для попереднього перегляду)',
  },
  publishEveryDays: {
    'en-us': 'Publish every N days',
    'de-ch': 'Alle N Tage veröffentlichen',
    'es-es': 'Publicar cada N días',
    'fr-fr': 'Publier tous les N jours',
    'ru-ru': 'Публиковать каждые N дней',
    'uk-ua': 'Публікуйте кожні N днів',
  },
  publish: {
    'en-us': 'Publish',
    'de-ch': 'Veröffentlichen',
    'es-es': 'Publicar',
    'fr-fr': 'Publier',
    'ru-ru': 'Публиковать',
    'uk-ua': 'Опублікувати',
  },
  fileName: {
    'en-us': 'File name',
    'de-ch': 'Dateiname',
    'es-es': 'Seleccione la tabla primero',
    'fr-fr': "Sélectionnez d'abord le tableau",
    'ru-ru': 'Сначала выберите таблицу',
    'uk-ua': 'Спочатку виберіть таблицю',
  },
  runAsUser: {
    'en-us': 'Run as user',
    'de-ch': 'Als Benutzer ausführen',
    'es-es': 'Ejecutar como usuario',
    'fr-fr': "Exécuter en tant qu'utilisateur",
    'ru-ru': 'Запуск от имени пользователя',
    'uk-ua': 'Запуск від імені користувача',
  },
  notifyUser: {
    'en-us': 'Send completion notification to user',
    'de-ch': 'Abschlussbenachrichtigung an Benutzer senden',
    'es-es': 'Enviar notificación de finalización al usuario',
    'fr-fr': "Envoyer une notification d'achèvement à l'utilisateur",
    'ru-ru': 'Отправить уведомление о завершении пользователю',
    'uk-ua': 'Надіслати сповіщення про завершення користувачеві',
  },
  runInCollection: {
    'en-us': 'Run in collection',
    'de-ch': 'In Sammlung ausführen',
    'es-es': 'Ejecutar en colección',
    'fr-fr': 'Exécuter en collection',
    'ru-ru': 'Запустить в коллекцию',
    'uk-ua': 'Запустити в колекції',
  },
  createNewForm: {
    'en-us': 'Create a new view definition',
    'de-ch': 'Definition',
    'es-es': 'Crear una nueva definición de vista',
    'fr-fr': 'Créer une nouvelle définition de vue',
    'ru-ru': 'Создайте новое определение представления',
    'uk-ua': 'Створіть нове визначення подання',
  },
  copyFromExistingForm: {
    'en-us': 'Copy existing view definition',
    'de-ch': 'Vorhandene Ansichtsdefinition kopieren',
    'es-es': 'Copiar la definición de vista existente',
    'fr-fr': 'Copier la définition de vue existante',
    'ru-ru': 'Копировать существующее определение представления',
    'uk-ua': 'Копіювати існуюче визначення перегляду',
  },
  copyDefaultForm: {
    'en-us': 'Copy default view definition',
    'de-ch': 'Standardansichtsdefinition kopieren',
    'es-es': 'Formateadores de registros',
    'fr-fr': "Formateurs d'enregistrement",
    'ru-ru': 'Форматеры записи',
    'uk-ua': 'Формати записів',
  },
  copyDefaultForms: {
    'en-us': 'Copy default forms',
    'de-ch': 'Standardformulare kopieren',
    'es-es': 'Copiar formularios predeterminados',
    'fr-fr': 'Copier les formulaires par défaut',
    'ru-ru': 'Копировать формы по умолчанию',
    'uk-ua': 'Копіювати стандартні форми',
  },
  saveFormFirst: {
    'en-us': 'Save form first',
    'de-ch': 'Formular vorher speichern',
    'es-es': 'Guarde el formulario primero',
    'fr-fr': "Enregistrez d'abord le formulaire",
    'ru-ru': 'Сначала сохраните форму',
    'uk-ua': 'Спочатку збережіть форму',
  },
  saveFormFirstDescription: {
    'en-us': 'You need to save this form before you edit another one',
    'de-ch':
      'Sie müssen dieses Formular speichern, bevor Sie ein anderes bearbeiten',
    'es-es': 'Debes guardar este formulario antes de editar otro.',
    'fr-fr':
      "Vous devez enregistrer ce formulaire avant d'en modifier un autre",
    'ru-ru':
      'Вам необходимо сохранить эту форму, прежде чем редактировать другую.',
    'uk-ua': 'Вам потрібно зберегти цю форму, перш ніж редагувати іншу',
  },
  conditionalFormatter: {
    'en-us': 'Conditional Format',
    'de-ch': 'Bedingtes Format',
    'es-es': 'Formato condicional',
    'fr-fr': 'Format conditionnel',
    'ru-ru': 'Условный формат',
    'uk-ua': 'Умовний формат',
  },
  customizeFieldFormatters: {
    'en-us': 'Customize Field Formats',
    'de-ch': 'Feldformate anpassen',
    'es-es': 'Personalizar formatos de campo',
    'fr-fr': 'Personnaliser les formats de champs',
    'ru-ru': 'Настройте форматы полей',
    'uk-ua': 'Налаштувати формати полів',
  },
  expandConditionalField: {
    'en-us': 'Expand Conditional Field',
    'de-ch': 'Bedingtes Feld erweitern',
    'es-es': 'Expandir campo condicional',
    'fr-fr': 'Développer le champ conditionnel',
    'ru-ru': 'Развернуть условное поле',
    'uk-ua': 'Розгорнути умовне поле',
  },
  collapseConditionalField: {
    'en-us': 'Collapse Conditional Field',
    'de-ch': 'Bedingtes Feld reduzieren',
    'es-es': 'Contraer campo condicional',
    'fr-fr': 'Réduire le champ conditionnel',
    'ru-ru': 'Свернуть условное поле',
    'uk-ua': 'Згорнути умовне поле',
  },
  conditionalFieldValue: {
    'en-us': 'Conditional Field Value',
    'de-ch': 'Bedingter Feldwert',
    'es-es': 'Valor de campo condicional',
    'fr-fr': 'Valeur du champ conditionnel',
    'ru-ru': 'Условное значение поля',
    'uk-ua': 'Умовне значення поля',
  },
  formatPreview: {
    'en-us': 'Format Preview',
    'de-ch': 'Feldformate anpassen',
    'es-es': 'Vista previa de formato',
    'fr-fr': 'Aperçu du format',
    'ru-ru': 'Предварительный просмотр формата',
    'uk-ua': 'Попередній перегляд формату',
  },
  currentDeterminationRequired: {
    'en-us': 'A current determination is required.',
    'de-ch': 'Eine aktuelle Feststellung ist erforderlich.',
    'es-es': 'Se requiere una determinación actual.',
    'fr-fr': 'Une détermination actuelle est requise.',
    'ru-ru': 'Требуется текущее определение.',
    'uk-ua': 'Потрібне поточне визначення.',
  },
} as const);
